const useStyles = {
  bookmarkContainer: {
    '& > div > button': {
      opacity: 0,
    },
    '&:hover': {
      '& > div > button': {
        opacity: 1,
      },
    },
  },
}
export default useStyles
